import { FREELANCECLIENTDASHBOARDJOBCOUNT } from "../../ENVIRONMENT";

// api for freelance dashboard job count
function freedashboardJobCount(token) {
  const response = fetch(FREELANCECLIENTDASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freedashboardJobCount };
